import { useState } from 'react'
import CtaButton from '../../ctaButton/CtaButton'
import LabeledSelectMenu from '../../labeledSelectMenu/LabeledSelectMenu'
import './style.scss'
import { PAGE_URLS } from '../../../constants/hrefLinks'
import { userStateData } from '../../../data/userStateData'

interface InstructorProfileDetailsProps {
	imgs: string[]
	choosenImgIndex: number
	price: string
	imgSelected: (imgIndex: number) => void
	groupSizes?: string
	instructorLevel: number,
	id: string
}

function InstructorProfileDetails({imgs, choosenImgIndex, price, imgSelected, groupSizes, instructorLevel, id}: InstructorProfileDetailsProps) {

	// const prices: number[] = [20, 25, 30, 35, 40]

	const [groupSize, setGroupSize] = useState<string>(groupSizes ? groupSizes[0] : '1')

	const profileImgClickHandler = (index: number) => {
		imgSelected(index)
	}

	const bookNowButtonClickHandler = () => {
		if (userStateData.loggedIn) {
			const priceInPennies: string = price.replace('.', '')
			window.location.replace(`${PAGE_URLS.CREATE_NEW_CHAT}?instructorId=${id}&cost=${priceInPennies}`)
		} else {
			window.location.replace(`${PAGE_URLS.LOG_IN}`)
		}
	}

	const groupSizeChangeHandler = (newValue: string) => {
		setGroupSize(newValue)
	}

	return (
		<div className="instructor-details-wrap">
			<div className="instructor-details-imgs-wrap">
				<div className="instructor-details-imgs-additional-wrap">
					{imgs.map((imgSrc, index) => 
						choosenImgIndex !== index &&
							<div
								className="instructor-details-imgs-img-wrap"
							>
								<img
									className="instructor-details-imgs-img"
									src={imgSrc}
									alt={`profileImg${index}`}
									key={`profileImg${index}`}
									onClick={() => profileImgClickHandler(index)}
								/>
							</div>
					)}
					{/* {imgs.map((imgSrc, index) => 
						choosenImgIndex !== index &&
							<img
								className="instructor-details-imgs-img"
								src={imgSrc}
								alt={`profileImg${index}`}
								key={`profileImg${index}`}
								onClick={() => profileImgClickHandler(index)}
							/>
					)} */}
				</div>
			</div>
			<div className='instructor-details-area'>
				<div className='instructor-details-area-price-wrap'>
					{/* <span className='instructor-details-area-price'>£{prices[Number(groupSize)]}.00</span> */}
					<span className='instructor-details-area-price'>$ {Number(parseInt(price) * parseInt(groupSize)).toFixed(2)}</span>
					<span className='instructor-currency-text'>NZD</span>
					<span className='instructor-details-area-service'> / session</span>
				</div>
				{groupSizes &&
					<LabeledSelectMenu 
						label='Group Size - Coming Soon'
						// options={groupSizes.split(',')}
						options={['', '1', '2', '3']}
						onChange={groupSizeChangeHandler}
						// value={groupSize}
						disabled={true}
					/>
				}
				<div
					className='instructor-details-area-options-label'
				>Rates</div>
				<div className='instructor-details-area-rates-option'>
					<div className='instructor-details-area-rates-option-title'>Instructor Level</div>
					<div className={`instructor-details-area-rates-option-level instructor-details-area-rates-option-level-${instructorLevel}`}>Level {instructorLevel}</div>
					{/* <div className='instructor-details-area-rates-option-value'>£{prices[Number(groupSize)]}.00</div> */}
					<span className='instructor-details-area-rates-option-value'>$ {Number(parseInt(price) * parseInt(groupSize)).toFixed(2)}</span>
					<div className='instructor-details-area-rates-option-radio-wrap' />
				</div>
				<CtaButton
					label='Book Now'
					onClick={() => { bookNowButtonClickHandler() }}
					size='medium'
					fullWidth={true}
				/>
				<div className='instructor-profile-details-sub-text'>You won't be charged yet</div>
			</div>
		</div>
	)
}

export default InstructorProfileDetails